import { computed, type ComputedRef } from 'vue'
import { useAuthenticationStore } from '@cplug/frontend-shared-domains/domain/authentication'
import { StateNames } from '~/domain/shared/address/models/City'

// Mapeamento estado brasileiro → IANA timezone
// Referência: https://en.wikipedia.org/wiki/Time_in_Brazil
const STATE_TIMEZONE_MAP: Record<StateNames, string> = {
  [StateNames.AC]: 'America/Rio_Branco', // UTC-5
  [StateNames.AM]: 'America/Manaus', // UTC-4
  [StateNames.RO]: 'America/Porto_Velho', // UTC-4
  [StateNames.RR]: 'America/Boa_Vista', // UTC-4
  [StateNames.MT]: 'America/Cuiaba', // UTC-4
  [StateNames.MS]: 'America/Campo_Grande', // UTC-4
  [StateNames.PA]: 'America/Belem', // UTC-3
  [StateNames.AP]: 'America/Belem', // UTC-3
  [StateNames.MA]: 'America/Fortaleza', // UTC-3
  [StateNames.PI]: 'America/Fortaleza', // UTC-3
  [StateNames.CE]: 'America/Fortaleza', // UTC-3
  [StateNames.RN]: 'America/Fortaleza', // UTC-3
  [StateNames.PB]: 'America/Fortaleza', // UTC-3
  [StateNames.PE]: 'America/Recife', // UTC-3
  [StateNames.AL]: 'America/Maceio', // UTC-3
  [StateNames.SE]: 'America/Maceio', // UTC-3
  [StateNames.BA]: 'America/Bahia', // UTC-3
  [StateNames.TO]: 'America/Araguaina', // UTC-3
  [StateNames.GO]: 'America/Sao_Paulo', // UTC-3
  [StateNames.DF]: 'America/Sao_Paulo', // UTC-3
  [StateNames.MG]: 'America/Sao_Paulo', // UTC-3
  [StateNames.ES]: 'America/Sao_Paulo', // UTC-3
  [StateNames.RJ]: 'America/Sao_Paulo', // UTC-3
  [StateNames.SP]: 'America/Sao_Paulo', // UTC-3
  [StateNames.PR]: 'America/Sao_Paulo', // UTC-3
  [StateNames.SC]: 'America/Sao_Paulo', // UTC-3
  [StateNames.RS]: 'America/Sao_Paulo' // UTC-3
}

export function inferTimezoneFromState (state?: StateNames): string | undefined {
  if (!state) { return undefined }
  return STATE_TIMEZONE_MAP[state]
}

export function useTimezoneFromCompany (): ComputedRef<string | undefined> {
  const authStore = useAuthenticationStore()

  return computed<string | undefined>(() => {
    const company = authStore.companies[0]
    const defaultAddress = company?.addresses?.find(a => a.type === 'default') ?? company?.addresses?.[0]
    const state = defaultAddress?.address?.city?.state as StateNames | undefined
    return inferTimezoneFromState(state) ?? Intl.DateTimeFormat().resolvedOptions().timeZone
  })
}
